import { render, staticRenderFns } from "./Audiometry.vue?vue&type=template&id=56f17151&scoped=true"
import script from "./Audiometry.vue?vue&type=script&lang=js"
export * from "./Audiometry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f17151",
  null
  
)

export default component.exports